/**
 * Host helpers for goodleap.plus vanity domains (same SPA / CloudFront as goodleap.dev).
 *
 * - goodleap.plus / www.goodleap.plus → marketing home at `/`, apply at `/:id`
 * - financing.goodleap.plus → Financing+ Toolkit at `/`, apply at `/:id` (same apply as goodleap.plus)
 * - pay.goodleap.plus / pay.goodleap.link / pay.goodleap.dev → pay flow at `/:id`
 * - www.goodleap.dev → pay via `/:id/payments` or `/pay/:id`
 */

function hostname() {
  if (typeof window === "undefined") return "";
  return String(window.location.hostname || "").toLowerCase();
}

/** financing.goodleap.plus — toolkit at `/`, GoodLeap Plus apply at `/:id`. */
export function isFinancingPlusDomain() {
  return hostname() === "financing.goodleap.plus";
}

/**
 * Dedicated pay hosts — payment flow at `/:id`.
 * On www / apex goodleap.dev use `/:id/payments` or `/pay/:id` instead.
 */
export function isPayDomain() {
  const h = hostname();
  return (
    h === "pay.goodleap.plus" ||
    h === "pay.goodleap.link" ||
    h === "pay.goodleap.dev"
  );
}

/**
 * Any goodleap.plus host (including financing. / www. / pay.).
 * Used by the apply flow for domain-aware UI (return URLs, branding).
 */
export function isGoodLeapPlusDomain() {
  return hostname().includes("goodleap.plus");
}

/**
 * Apex/www goodleap.plus only — marketing home at `/`.
 * Excludes financing. and pay. so those hosts use their own `/` routes.
 */
export function isGoodLeapPlusMarketingDomain() {
  const h = hostname();
  if (!h.includes("goodleap.plus")) return false;
  if (isFinancingPlusDomain()) return false;
  if (isPayDomain()) return false;
  return true;
}
